/**
 * Dates travel to the backend as plain calendar days, never as offset-bearing timestamps.
 * Sending `moment().startOf('day').format()` embeds the *browser's* offset, and the server then
 * re-reads that instant in Asia/Jakarta — so a user in WIT (UTC+9) picking 31 May would have the
 * server resolve it to 30 May. A bare 'YYYY-MM-DD' is parsed as UTC midnight, which lands on the
 * same calendar day in any positive-offset server timezone.
 *
 * Kept here rather than in DashboardFilterBar: the filter bar renders DashboardRangePresets, and
 * the presets need this format, so exporting it from the filter bar made the two import each other.
 */
export const DASHBOARD_DATE_FORMAT = 'YYYY-MM-DD';
